import {createActions} from 'client/framework';

const normalActions = ['ENABLE_MASQUERADING', 'DISABLE_MASQUERADING'];

export default createActions(null, normalActions);
